import { useEffect, useRef, useState } from 'react';
import { getBrazeInstance } from '../client';
import { hasUnseenContentCards } from '../handlers/contentCards';

export function useBrazeNotificationRedDot(isDrawerOpen: boolean) {
    const [hasNotification, setHasNotification] = useState(false);
    const brazeRef = useRef<any>(null);

    useEffect(() => {
        let isMounted = true;

        const initBraze = async () => {
            const braze = await getBrazeInstance();
            brazeRef.current = braze;

            const checkUnseen = async () => {
                const unseen = await hasUnseenContentCards();
                if (isMounted && !isDrawerOpen) {
                    setHasNotification(unseen);
                }
            };

            await checkUnseen();

            braze.subscribeToContentCardsUpdates(() => {
                if (!isMounted || isDrawerOpen) return;
                checkUnseen();
            });
        };

        initBraze();

        return () => {
            isMounted = false;
        };
    }, [isDrawerOpen]);

    useEffect(() => {
        let isMounted = true;

        const interval = setInterval(async () => {
            if (!isMounted) return;

            try {
                const unseen = await hasUnseenContentCards();
                setHasNotification(unseen);
            } catch (err) {
                console.error(
                    '[Polling] Failed to fetch unseen content cards:',
                    err,
                );
            }
        }, 60000);

        return () => {
            isMounted = false;
            clearInterval(interval);
        };
    }, [isDrawerOpen]);

    useEffect(() => {
        if (isDrawerOpen) {
            setHasNotification(false);
        }
    }, [isDrawerOpen]);

    return hasNotification;
}
